import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=2a9c58d9&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=2a9c58d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c58d9",
  null
  
)

export default component.exports